// extracted by mini-css-extract-plugin
export default {"section":"Services_section__Wk1Z7","wrapper":"Services_wrapper__btCSk"};